import type { PlatformTenantStatus } from "@/services/platformTenantsService";

/**
 * How a platform tenant's status renders as a badge.
 *
 * Extracted because it existed three times — tenants-page, TenantMobileCard
 * and tenant-detail-page's own STATUS_VARIANT record — and adding a fifth
 * status meant editing all three, with nothing to catch the one you missed.
 * That is the same shape that produced five separate bugs across the Literal E
 * surfaces on 2026-09-29/30.
 *
 * Typed against PlatformTenantStatus rather than a hand-listed union, so a new
 * status is a compile error here instead of a silently unstyled badge.
 */
export type TenantStatusBadgeVariant =
  | "success"
  | "info"
  | "warning"
  | "danger";

export function statusBadgeVariant(
  status: PlatformTenantStatus,
): TenantStatusBadgeVariant {
  switch (status) {
    case "active":
      return "success";
    case "onboarding":
      return "info";
    // Not a warning. The review is DONE and the answer was no: the tenant is
    // blocked from emitting until they pick another plan, which somebody has
    // to act on rather than wait out.
    case "literal_e_rejected":
      return "danger";
    case "pending_approval":
    case "pending_deletion":
      return "warning";
  }
}
